import { useQuery } from '@apollo/client';
import { Col } from 'antd';
import CircularProgress from 'components/CircularProgress';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { ProfileIcon } from 'routes/Profile/components/ProfileContent/styled';
import { GET_SINGLE_COMPANY } from 'services/graphql/queries/company.query';
import { ICompany } from 'types/company';

import GeneralInformation from './components/GeneralInformation';

const Company: React.FC = () => {
  const { company: companyState } = useCurrentLoggedInUser(); // test nha
  const { loading, data, refetch } = useQuery<{ findOneCompanyEntity: ICompany }>(GET_SINGLE_COMPANY, {
    variables: {
      id: companyState?.id,
    },
  });

  const company = data?.findOneCompanyEntity;

  // useEffect(() => {
  //   dispatch(UserAction.updateUserSuccess({ company }));
  // }, [company]);

  // if (loading) return <CircularProgress />;
  // todo: error 500 page
  // if (error) return <ServerError />;
  // if (error) return <div><ContentHeader titleId='contactInformation' /></div>;

  return (
    <div className='p-6'>
      <div className='capitalize font-medium text-lg m-0 flex items-center'>
        <Col>
          <ProfileIcon className='icon icon-home' />
        </Col>
        <Col>
          <span>Company</span>
        </Col>
        <Col>
          <div className='save-company-button ml-5' />
        </Col>
      </div>
      {loading && <CircularProgress />}
      {!loading && (
        <div className='p-6 max-w-lg'>
          <GeneralInformation
            company={company}
            refetchCompanyData={refetch}
            portalButtonClassName='.save-company-button'
          />
        </div>
      )}
    </div>
  );
};

export default Company;
